"use client";
import { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Image from "next/image";

const SamplePrevArrow = (props: any) => {
  const { onClick } = props;
  return (
    <button aria-label="Prev Customer" className={`!w-12 !h-12 bg-white flex justify-center items-center rounded-full custom-btn-shadow absolute top-1/2 -translate-y-1/2 right-[100%]`} onClick={onClick}>
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none" className="!w-2 !h-5"><path d="M7 1L1 7.03991L7 13" stroke="#001630" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg>
    </button>
  );
}

const SampleNextArrow = (props: any) => {
  const { onClick } = props;
  return (
    <button aria-label="Next Customer" className={`!w-12 !h-12 bg-white flex justify-center items-center rounded-full custom-btn-shadow absolute top-1/2 -translate-y-1/2 left-[100%]`} onClick={onClick}>
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none" className="!w-2 !h-5"><path d="M1 1L7 7.03991L1 13" stroke="#001630" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg>
    </button>
  );
}

export default function QualitiaCustomersAnimation() {
  const settings: any = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    autoplay: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 0,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false
        }
      }
    ]
  };
  const customersData = {
    Heading: "Qualitia Customers",
    customers: [
      { src: "/customersImage/pwc.png", alt: "PWC" },
      { src: "/customersImage/philips.png", alt: "Philips" },
      { src: "/customersImage/ge_healthcare.png", alt: "GE healthcare" },
      { src: "/customersImage/metlife.png", alt: "MetLife" },
      { src: "/customersImage/prudential.png", alt: "Prudential" },
      { src: "/customersImage/cibc.png", alt: "CIBC" },
      { src: "/customersImage/ptc.png", alt: "PTC" },
      { src: "/customersImage/qlik.png", alt: "Qlik" },
      { src: "/customersImage/springer.png", alt: "Springer" },
      { src: "/customersImage/pitney_bowes.png", alt: "pitney bowes" },
      { src: "/customersImage/sbi.png", alt: "SBI" },
      { src: "/customersImage/hdfc.png", alt: "HDFC Bank" },
      { src: "/customersImage/kotak.png", alt: "Kotak Mahindra Bank" },
      { src: "/customersImage/axis.png", alt: "Axis Bank" },
      { src: "/customersImage/aditya_birla_capital.png", alt: "Aditya Birla Capital" },
      { src: "/customersImage/india_first_life.png", alt: "India First" },
      { src: "/customersImage/bse.png", alt: "BSE" },
      { src: "/customersImage/newrez.png", alt: "newrez" },
      { src: "/customersImage/whirlpool.png", alt: "Whirpool" },
    ],
  };

  return (
    <>
      <div className='px-10 xl:p-0 xl:max-w-[1128px] w-full mb-[36px]'>
        <Slider {...settings}>
          {customersData.customers.map((customer, index): any => {
            const { src, alt } = customer;
            return (
              <div key={index} className="p-3">
                  <div className='w-full bg-white border border-[#DBDBDB] rounded-xl py-5 px-7'>
                    <img
                      style={{ width: "100%" }}
                      src={src}
                      alt={alt}
                      className='object-contain'
                    />
                  </div>
              </div> 
            );
          })
          }
        </Slider>
      </div>
    </>
  );
}
